import _get from 'lodash/get';

import INITIAL_STATE from './initialState';

/**
 * Store the MFA session built from the authenticate API response.
 *
 * @method setMFASession
 * @param  {Object}      state  The current state
 * @param  {Object}      action The dispatched action
 * @return {Object}             The updated state
 */
export const setMFASession = (state, action) => {
    const payload = _get(action, 'payload', {});

    return {
        ...state,
        allowedMethods: _get(payload, 'allowedMethods', []),
        error: null,
        isVerifying: false,
        loginContext: _get(payload, 'loginContext', {}),
        method: _get(payload, 'method', ''),
        mfaToken: _get(payload, 'mfaToken', ''),
        status: _get(payload, 'status', ''),
    };
};

/**
 * Clear the MFA session, i.e. reset the 'mfa' state.
 *
 * @method clearMFASession
 * @return {Object} The initial state
 */
export const clearMFASession = () => ({ ...INITIAL_STATE });

/**
 * Flag the verification request as in flight.
 *
 * @method verifyMFACodeRequest
 * @param  {Object}             state The current state
 * @return {Object}                   The updated state
 */
export const verifyMFACodeRequest = state => ({
    ...state,
    error: null,
    isVerifying: true,
});

/**
 * Handle a failed verification attempt.
 *
 * NOTE: the raw error is kept as is, it carries the `errorCode` and the
 * `remainingAttempts` the screen derives its error state from.
 *
 * @method verifyMFACodeError
 * @param  {Object}           state  The current state
 * @param  {Object}           action The dispatched action
 * @return {Object}                  The updated state
 */
export const verifyMFACodeError = (state, action) => ({
    ...state,
    error: _get(action, 'payload', null),
    isVerifying: false,
});
